<template>
  <div style="width:50%">
  <v-client-table class="salaire-tab"
    :columns="salairesColumns"
    :data="salairesItems"
    :options="salairesOptions"
  >
    <div v-if="props.row.nom_mois" slot="nom_mois" slot-scope="props">
      <span>{{ props.row.nom_mois }}</span>
    </div>
    <div v-if="props.row.montant_brut_cotise" slot="montant_brut_cotise" slot-scope="props" class="slot-number">
      <span>{{ replaceDotToComma(formatNumber(props.row.montant_brut_cotise)) }} €</span>
    </div>
    <div v-if="props.row.montant_reconstitue" slot="montant_reconstitue" slot-scope="props" class="slot-number">
      <span>{{ replaceDotToComma(formatNumber(props.row.montant_reconstitue)) }} €</span>
    </div>
    <div v-if="props.row.motif" slot="motif" slot-scope="props">
      <span>{{ props.row.motif }}</span>
    </div>
  </v-client-table>
  </div>
</template>

<script>
  import { replaceDotToComma, formatNumber } from "@/utils/communHelper";

  export default {
    name: "SalaireListing",
    data() {
      let self = this;
      return {
        salairesColumns: ['nom_mois', 'montant_brut_cotise', 'montant_reconstitue', 'motif'],
        salairesItems: [],
        salairesOptions: {
          headings: {
            nom_mois: "Mois",
            montant_brut_cotise: "Montant brut cotisé",
            montant_reconstitue: "Montant reconstitué",
            motif: "Motif"
          },
          sortable: [],
            filterable: false,
            perPage: 12,
            perPageValues: [12, 25, 50],
        },
        replaceDotToComma,
        formatNumber
      }
    },
    props: ['dossier'],
    mounted() {
	  if (this.dossier) {
	    this.salairesList()
      	this.$event.emit('stopLoadingSalairesListing');
	  }
	},
    methods: {
      salairesList() {
      	this.salairesItems = this.dossier.salaires
      }
    }
  }
</script>
